import React from 'react';

function Four() {
    return (
        <div className="blog-post">
            <h1>AI-Native Employees and Computer Science Educational Changes</h1>
            <small>02-16-2026</small>
            <p>
                This week in my AI class, we have a special guest visit on Tuesday. His name is <a href='https://www.linkedin.com/in/jefflarkin/' target="_blank" rel="noopener noreferrer">Jeff Larkin</a> and 
                he's the director of high-performance computing at NVIDIA. In preparation for his presentation,
                we've been provided with two sources to look into. It was very interesting to read Elena Verna's
                article about <a href='https://www.elenaverna.com/p/the-rise-of-the-ai-native-employee' target='_blank' rel='noopener noreferrer'> The Rise of the AI-native Employee</a> and
                listen to part three of <a href='https://podwise.ai/dashboard/episodes/6197400' target='_blank' rel='noopener noreferrer'>Joe Rogan's interview with Jensen Huang</a>,
                CEO of NVIDIA. Following reading and listening to these sources, I'll be playing the role of a computer science educator
                to share my thoughts on how the curriculum should change.
            </p>
            <br />
            <h2>How Would I Change Computer Science Curriculum?</h2>
            <p>
                As of now, the CS curriculum is largely based on the fundamentals of coding, and how to equip
                students with those ideas as effective problem solvers. Foundational classes such as data
                structures & algorithms, discrete math and systems level programming are still very important,
                despite the growth of AI. The aspect of current education that I disagree with is the application
                of said foundational principles. As educators, we're tasked with producing graduates who are prepared
                for the industry.
            </p>
            <br />
            <p>
                In the real world, employees use AI to help them complete tasks at a much faster rate, while
                employing smaller teams. When coding with AI, employees are required to know what they're asking
                for and what AI is generating, but less low level coding is required of them. Along with that,
                employees may design a system, only to ask AI to write most of the code for them. To make our
                curriculum more applicable, I would expand the foundation of required classes, adding an AI literacy
                class (software engineering with AI) and a system design class. Aside from the foundational
                principles, electives would need a structure change of some sort. Specifically the way that students
                are evaluated in electives should be revised. If it were up to me, AI usage would not be forbidden
                on coding assignments. Students would be expected to use AI with the integrity and literacy that
                they've learned their required AI literacy class. The exams would be entirely conceptual. That way,
                students wouldn't be forced to write code on a piece of paper when a machine is able to write most
                of it for them.
            </p>
        </div>
    );
}

export default Four;